(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["alinga-reviewsio-stars"] && !Shopify.designMode) return;
  try {
    /* The REVIEWS.io embed no longer runs its first pass on its own, so trigger it here,
     and again whenever new unfilled snippets appear (filters, pagination, sliders). */
  (function () {
    var timer = null;
    var tries = 0;
    function run() {
      if (typeof window.reinitialiseRatingSnippet !== 'function' || !window.ratingSnippetGlobalSettings) return false;
      var pending = document.querySelectorAll('.alinga-reviewsio-stars .ruk_rating_snippet:empty');
      if (pending.length) window.reinitialiseRatingSnippet();
      return true;
    }
    function schedule(delay) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!run() && ++tries < 30) schedule(500);
      }, delay);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { schedule(300); });
    } else {
      schedule(300);
    }
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('.alinga-reviewsio-stars') || n.querySelector('.alinga-reviewsio-stars'))) {
            schedule(250);
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
